import React, { useEffect } from "react";
import { Redirect, RedirectProps } from "react-router-dom";
import { useNotification } from "../../sg-core/hooks/useToast";

interface RedirectAndNotifyProps extends RedirectProps {
    note: string;
    status: "success" | "error" | "info"

};

export const RedirectAndNotify: React.FC<RedirectAndNotifyProps> = ({ status, note, ...props }) => {
    const toast = useNotification()

    useEffect(() => {
        const notify = toast[status];
        notify(note)
    }, []);//eslint-disable-line

    return (
        <Redirect
            {...props}
        />
    )
};


